"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
// Logic copied from https://stackoverflow.com/a/63836797
var ImgWithPlaceholder = function (props) {
    var placeholderSrc = props.placeholderSrc, baseProps = __rest(props, ["placeholderSrc"]);
    var _a = (0, hooks_1.useState)(false), loaded = _a[0], setLoaded = _a[1];
    var ref = (0, hooks_1.useRef)(null);
    var onLoad = function () {
        setLoaded(true);
    };
    (0, hooks_1.useEffect)(function () {
        if (ref.current && ref.current.complete) {
            onLoad();
        }
    }, []);
    // loads both placeholder and gif
    // hides gif until it finishes loading
    // hides placeholder after it finishes loading
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("img", __assign({ style: !loaded ? { display: 'none' } : {} }, baseProps, { ref: ref, onLoad: onLoad })),
        (0, preact_1.h)("img", __assign({ style: loaded ? { display: 'none' } : {} }, baseProps, { src: placeholderSrc }))));
};
exports.default = ImgWithPlaceholder;
